import { render, staticRenderFns } from "./ProductsOrder.vue?vue&type=template&id=1457fd2f&"
import script from "./ProductsOrder.vue?vue&type=script&lang=js&"
export * from "./ProductsOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports